import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["sortableList", "listContainer"];

  connect() {
    this.appendNewActivityForm = this.appendNewActivityForm.bind(this);
    this.reinitializeDragHandler = this.reinitializeDragHandler.bind(this)
    App.Helpers.listenToCustomEvent(document, "sortable-checklist-new-item-form-fetch:success", this.appendNewActivityForm);
    this.dragHandler = App.DragHandler.init(this.sortableListTargets, {
      dropHandler: this.dropHandler.bind(this),
      dragEndHandler: this.postChange.bind(this),
      ...this.sortableListTargets
    })
    App.Helpers.listenToCustomEvent(document, "checklists:items-update", this.reinitializeDragHandler);
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "sortable-checklist-new-item-form-fetch:success", this.appendNewActivityForm)
    App.Helpers.removeCustomEventListener(document, "checklists:items-update", this.reinitializeDragHandler)
  }

  reinitializeDragHandler() {
    this.dragHandler.reinitializeWith(this.sortableListTargets)
  }

  dropHandler(el, target, source) {
    this.shouldPostChange = true;
    el.sourceListID = source.dataset.listId;
    el.targetListID = target.dataset.listId;
  }

  postChange(el) {
    if (this.shouldPostChange) {
      App.Helpers.ajaxRequest({
        url:            this.urlFor(el),
        method:         "POST",
        data:           this.positionDataFor(el),
        successHandler: (() => this.emitPostChangeSuccessEvent(el)).bind(this),
        errorHandler:   (({responseText}) => this.displayMoveErrorFor(el, responseText)).bind(this)
      });
    }
    this.shouldPostChange = false;
  }

  emitPostChangeSuccessEvent(el) {
    const { sourceListID, targetListID } = el;
    if (sourceListID !== targetListID) {
      document.dispatchEvent(createCustomEvent("checklists:items-update", this.element, { sourceListID, targetListID }));
    }
  }

  appendNewActivityForm(event) {
    const { html, listID } = event.detail;
    if (this.listID == listID) {
      App.Helpers.appendContent(this.sortableListTarget, html);
    }
  }

  updateList(response) {
    App.Helpers.replaceElement(this.element, response.html);
    document.dispatchEvent(createCustomEvent("checklists:items-update", this.element));
  }

  positionDataFor(el) {
    return {
      checklist_item: { position: this.positionOf(el) }
    };
  }

  positionOf(el) {
    return [...this.allItemsInListFor(el)].indexOf(el) + 1;
  }

  displayMoveErrorFor(el, errorMsg) {
    const errorEl = `<span class="text-error">List item move failed: ${errorMsg}</span>`;
    App.Helpers.appendBefore(errorEl, el);
  }

  allItemsInListFor(el) {
    return [...el.parentNode.children];
  }

  urlFor(el) {
    return el.dataset.moveUrl.replace(/LIST_ID/g, this.listIDFor(el))
  }

  listIDFor(el) {
    return el.parentNode.dataset.listId;
  }

  //
  // GETTERS AND SETTERS
  //

  get listID() {
    return this.sortableListTarget.dataset.listId;
  }

  get openFormSelector() {
    return "form"
  }

  get openFormCount() {
    return [...this.element.querySelectorAll(this.openFormSelector)].length;
  }

  get containerID() {
    return this.data.get("container-id")
  }

  get shouldPostChange() {
    return !!this._shouldPostChange;
  }

  set shouldPostChange(val) {
    this._shouldPostChange = val;
  }

  get dragHandlerOptions() {
    return { revertOnSpill: true }
  }
}



// WEBPACK FOOTER //
// ./app/components/checklists/assets/javascript/checklists-sortable-list-controller.js